import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.generateMycologicalRegistryDoc.success: {
            return action.payload;
        }

        case constants.generateMycologicalRegistryDoc.try: {
            return initialState;
        }

        case constants.generateMycologicalRegistryDoc.error: {
            return initialState;
        }

        default:
            return state;
    }
}